import { useState, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import PropTypes from "prop-types";
import "react-input-range/lib/css/index.css";
import UserContext from "../../../../context/UserContext";
import socket from "../../../../config/socket";

function ChangeBlinds({ handleBlindsClose }) {
  const { gameData } = useContext(UserContext);
  const [values, setValues] = useState();

  const handleInputChange = (e) => {
    setValues(Number(e.target.value));
  };

  const handleSubmit = async (e) => {
    e.preventDefault()
    socket.emit("setChipsAndMinBlind", { gameId: gameData.id, minBlind: values, type: "blinds" })
    handleBlindsClose();
  };

  return (
    <div className="change-stack">
      <Form onSubmit={(e) => handleSubmit(e)}>
        <Form.Label>Minimum blinds</Form.Label>
        <Form.Control
          type="number"
          name="chips"
          placeholder="Enter amount"
          defaultValue={values}
          onChange={handleInputChange}
        />
        <div className="stack-btn">
          <Button onClick={handleBlindsClose}>Cancel</Button>
          <Button type="submit">Change</Button>
        </div>
      </Form>
    </div>
  );
}
ChangeBlinds.propTypes = {
  handleBlindsClose: PropTypes.func.isRequired,
};

export default ChangeBlinds;
